/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import httpClient from 'utils/httpClient';
import { Session, TestResult } from './type';

export const GET_TESTING_RESULT_BY_COURSE_ID = (courseId: number) =>
  `/admin/v2/test-result/${courseId}`;

export type RetrieveTestResultQuery = {
  courseId: number;
};
export type RetrieveTestResultResponse = {
  data: {
    test_result_url: TestResult;
    video_url: string[];
  };
};

export const retrieveTestResult = ({ courseId }: RetrieveTestResultQuery) => {
  return httpClient.get<RetrieveTestResultResponse>(
    GET_TESTING_RESULT_BY_COURSE_ID(courseId),
    {},
  );
};

export const useRetrieveTestResult = (
  { courseId }: RetrieveTestResultQuery,
  opts?: UseQueryOptions<
    AxiosResponse<RetrieveTestResultResponse>,
    AxiosError<any>
  >,
) =>
  useQuery<AxiosResponse<RetrieveTestResultResponse>, AxiosError<any>>(
    [GET_TESTING_RESULT_BY_COURSE_ID(courseId)],
    () => retrieveTestResult({ courseId }),
    { ...opts, cacheTime: 0 },
  );
